import { BorderBox, Rhythm } from '@trmediaab/zebra';
import PropTypes from 'prop-types';

import Paywall from '~/containers/Auth/Paywall';
import { paragraphLiveBlogType } from '~/utils/prop-types';
import Sentry from '~/utils/sentry';

const LiveBlogIFrame = ({ url }) => {
  let aId = null;

  try {
    const params = new URLSearchParams(new URL(url).search);
    aId = params.get('aId');

    if (aId == null) {
      throw new Error(`Failed to get liveblog aID from ${url}.`);
    }
  } catch (error) {
    Sentry.captureException(error);
  }

  if (aId != null) {
    return (
      <BorderBox
        as="iframe"
        src={`${import.meta.env.VITE_LIVEBLOG_API_HOST}/?aId=${aId}`}
        allowFullScreen
        border="0"
        minHeight="710px"
        width="100%"
      />
    );
  } else {
    return null;
  }
};

// Access levels
// 1 = Open for subscribers
// 2 = Open for everyone

const LiveBlog = ({ paragraph, hasPremium }) => {
  const { access, broadcast_url: url } = paragraph;

  return (
    <BorderBox borderTop="1" borderBottom="1" pt="2" mt="2">
      <Rhythm color="text.faded" between="2" mb="2">
        {access === 1 && !hasPremium ? (
          <Paywall isArticle small />
        ) : (
          <LiveBlogIFrame url={url} />
        )}
      </Rhythm>
    </BorderBox>
  );
};

LiveBlog.propTypes = {
  paragraph: paragraphLiveBlogType.isRequired,
  hasPremium: PropTypes.bool,
};

export default LiveBlog;
